// src/utils/searchMatch.js
//
// Case-insensitive "does every word of the query appear somewhere in these
// fields" — the filter behind the Escalations & Notes search box. Empty query
// matches everything; null/undefined fields are ignored.
export function matchesQuery(query, ...fields) {
  const words = (query || '').toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = fields.filter(f => f != null && f !== '').join(' ').toLowerCase();
  return words.every(w => haystack.includes(w));
}
